import React, { useEffect, useRef, useState } from 'react';
import { Button } from '@indeed/ifl-components';
import { getPassportURL } from 'Utils/PassportUtil';
import './_PassportLinks.scss';
const BUTTON_ID_NEW_ACCOUNT = 1;
const BUTTON_ID_LOGIN = 2;
const PassportLinks = ({ nextPath }) => {
    const [loadingButton, setLoadingButton] = useState(0);
    const timerRef = useRef(null);
    // Set 10sec timeout after clicking login button to prevent infinite loading status when the login flow is interrupted or cancelled midway
    useEffect(() => {
        if (loadingButton !== 0) {
            timerRef.current = setTimeout(() => {
                setLoadingButton(0);
            }, 10000);
        }
        return () => {
            if (timerRef.current !== null)
                clearTimeout(timerRef.current);
        };
    }, [loadingButton]);
    return (React.createElement("div", { className: "PassportLinks" },
        React.createElement(Button, { className: "PassportLinks-createAccountAndStart", size: "md", full: true, disabled: loadingButton !== 0, loading: loadingButton === BUTTON_ID_NEW_ACCOUNT, onClick: () => {
                setLoadingButton(BUTTON_ID_NEW_ACCOUNT);
                location.assign(getPassportURL('signup', 'startpage', nextPath));
            } }, "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u4F5C\u6210\uFF08\u7121\u6599\uFF09"),
        React.createElement(Button, { size: "md", full: true, variant: "secondary", disabled: loadingButton !== 0, loading: loadingButton === BUTTON_ID_LOGIN, onClick: () => {
                setLoadingButton(BUTTON_ID_LOGIN);
                location.assign(getPassportURL('login', 'startpage', nextPath));
            } }, "\u30ED\u30B0\u30A4\u30F3")));
};
export default PassportLinks;
